import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/calldetailrecords', {
			params: searchParams
		})
	},

	count(searchParams) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/count', {
			params: searchParams
		})
	},

	getAllCombined(searchParams) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/combined', {
			params: searchParams
		})
	},

	getAllCombinedAsCsv(searchParams) {
		return axios.post(window.dtServerUrl + '/calldetailrecords/combined/csv', searchParams)
	},

	getRecentInternationalCalls(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/recent/international', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getRecentFailedCalls(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/recent/failed', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getRecentInboundCalls(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/recent/inbound', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getTopAccounts(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/lists/topaccounts', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getTopCarriers(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/lists/topcarriers', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getTopHangupCodes(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/lists/tophangupcodes', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getCallsByDayPerAccount(searchParams) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/lists/callsbydayperaccount', {
				params: searchParams
			})
			.then((response) => {
				return response?.data
			})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/' + id)
	},

	getByTeleflowId(teleflowId) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/teleflow/' + teleflowId)
	},

	getByIdDetailed(id) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/' + id + '/detail')
	},

	getSipCaptureById(id) {
		return axios.get(window.dtServerUrl + '/calldetailrecords/' + id + '/sipcapture').then((response) => {
			return response?.data
		})
	},

	downloadRecordingById(id) {
		return axios
			.get(window.dtServerUrl + '/calldetailrecords/' + id + '/downloadrecording', {
				responseType: 'blob'
			})
			.then((response) => {
				return response?.data
			})
	},

	create(tenant) {
		return axios.post(window.dtServerUrl + '/calldetailrecords', tenant)
	}
}
